import axios from "axios";

import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// SCRAP WALLET REPORT RELATED APIs
// ==============================================

// 1. Get Scrap Wallet Balance Items Report Data
export const getScrapWalletBalanceItemsReportData = async (params) => {
    try {
        const { CCCode, UID, Roleid } = params;
         // DEBUG
        
        // Validate required parameters
        if (!UID || !Roleid) {
            throw new Error('UID and Roleid are required parameters');
        }
        
        const queryParams = new URLSearchParams({
            CCCode: CCCode || '',
            UID: UID,
            Roleid: Roleid
        });
        
        const response = await axios.get(
            `${API_BASE_URL}/Reports/ScrapWalletBalanceItemsReportData?${queryParams}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 2. Get SWR Cost Center Codes
export const getSWRCostCenterCodes = async (params) => {
    try {
        const { UID, RID } = params;
         // DEBUG
        
        // Validate required parameters
        if (!UID || !RID) {
            throw new Error('UID and RID are required parameters');
        }
        
        const queryParams = new URLSearchParams({
            UID: UID,
            RID: RID
        });
        
        const response = await axios.get(
            `${API_BASE_URL}/Reports/GetSWRCostCenterCodes?${queryParams}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

